<!-- =========================================================================================
  File Name: ECommerceShop.vue
  Description: eCommerce Shop Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <vx-card title="DNA Traits">
      <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>

      <vs-table v-if="!loading" ref="table" class="pb-5" :data="traitScores">

        <template slot="thead">
          <vs-th sort-key="trait_id">Trait</vs-th>
          <vs-th sort-key="score">Score</vs-th>
          <vs-th sort-key="dna_report">DNA</vs-th>
          <vs-th sort-key="itovi_report">iTOVi</vs-th>
          <vs-th>&nbsp;</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody v-for="(traitScore, indextr) in data" :data="traitScore" :key="indextr" >
          <vs-tr class="cursor-pointer">

            <vs-td>
              <p class="font-medium truncate">{{ getTraitName(traitScore.trait_id) }} ({{ traitScore.trait_id }})</p>
            </vs-td>

            <vs-td>
              <p class="font-medium truncate">{{ traitScore.score }}</p>
            </vs-td>


            <vs-td>
              <vs-chip v-if="traitScore.dna_report" color="success">Yes</vs-chip>
              <vs-chip v-else color="warning">No</vs-chip>
            </vs-td>

            <vs-td>
              <vs-chip v-if="traitScore.itovi_report" color="success">Yes</vs-chip>
              <vs-chip v-else color="warning">No</vs-chip>
            </vs-td>

            <vs-td>
              <vs-button class="float-right mx-2" type="gradient" size="small" @click="confirmDeleteTraitScore(traitScore)" color="danger" icon="delete" ></vs-button>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>

      </vs-table>

      <vs-button class="ml-auto mt-5 pt-2" color="primary" type="border" icon-after icon="add" @click="showCreateTraitScoreDialog">New Trait/Score</vs-button>

      <vs-prompt
        @accept="createTraitScore"
        title="New DNA Trait/Score"
        :active.sync="showCreateTraitScoreDialogFlag">
        <div>


          <vs-select
            label="Trait (id)"
            v-model="newTraitScoreModel.trait_id"
            class="mr-4 w-full vs-input-shadow-drop vs-select-no-border">
            <vs-select-item
              v-for="item in traitSelectorOptions"
              :key="item.traitId"
              :value="item.traitId"
              :text="`${item.traitName} (${item.traitId})`"
            />
          </vs-select>


<!--          <div class="vx-row mb-2">-->
<!--            <div class="vx-col w-full">-->
<!--              <vs-input-->
<!--                class="w-full mb-1"-->
<!--                label-placeholder="Trait ID"-->
<!--                v-model="newTraitScoreModel.trait_id"-->
<!--              />-->
<!--            </div>-->
<!--          </div>-->


          <vs-select
            label="Score"
            v-model="newTraitScoreModel.score"
            class="mr-4 w-full vs-input-shadow-drop vs-select-no-border">
            <vs-select-item
              v-for="item in scoreSelectorOptions"
              :key="item.score"
              :value="item.score"
              :text="`${item.score} (${item.value})`"
            />
          </vs-select>

          <div class="vx-row mb-2 pt-2">
            <div class="vx-col w-full">
              <label class="label" for="dna-report-switch">Show on DNA Report</label>
              <vs-switch
                id="dna-report-switch"
                color="success"
                v-model="newTraitScoreModel.dna_report"/>
            </div>
          </div>

          <div class="vx-row mb-2 pt-2">
            <div class="vx-col w-full">
              <label class="label" for="itovi-report-switch">Show on iTOVi Report</label>
              <vs-switch
                id="itovi-report-switch"
                color="success"
                v-model="newTraitScoreModel.itovi_report"/>
            </div>
          </div>
<!--          <div class="vx-row mb-2">-->
<!--            <div class="vx-col w-full">-->
<!--              <vs-input-->
<!--                class="w-full mb-1"-->
<!--                label-placeholder="Score (e.g. 'normal')"-->
<!--                v-model="newTraitScoreModel.score"-->
<!--              />-->
<!--            </div>-->
<!--          </div>-->

        </div>
      </vs-prompt>

    </vx-card>
<!--    <div v-html="jp.toHtml(cyclopedias)"></div>-->
</template>

<script>
  import api from '@/http/api';
  import dnaApi from '@/http/dnaApi';
  import models from '@/models';
  import jsonPrinter from '@/misc/jsonHtmlPrinter';
  import { productHelpers } from '@/models/helpers'

  export default {
    components: {},
    data() {
      return {
        loading: false,
        models: models,
        jp: jsonPrinter,
        productHelpers: productHelpers,
        traitScores: [],
        showCreateTraitScoreDialogFlag: false,
        newTraitScoreModel: new models.ProductDnaTraitScore({ product_id: this.productId}),
        traitScoreDetails: [],
        traitSelectorOptions: []
      }
    },
    computed: {
      productId() {
        return this.$route.query.id || null;
      },
      scoreSelectorOptions() {
        let option = this.traitSelectorOptions.filter((item) => item.traitId === this.newTraitScoreModel.trait_id);
        if (option && option.length >= 1) return option[0].scores;
        return [];
      }
    },
    mounted() {
      this.fetchProductDnaTraitScores();
    },
    methods: {
      buildTraitSelectorOptions(){
        let uniqueTraitIds = [...new Set(this.traitScoreDetails.map((item) => item.traitId ))];

        this.traitSelectorOptions = uniqueTraitIds.map((id) => {
          return {
            traitId: id,
            traitName: this.getTraitName(id),
            scores: this.traitScoreDetails
              .filter((item) => item.traitId === id)
              .map((item) => { return { score: item.scoreName, value: item.value };})
              .sort((a, b) => a.value - b.value)
          };
        });
      },
      getTraitById(traitId){
        try {
          return this.traitScoreDetails.filter((item) => item.traitId === traitId)[0];
        } catch (e) {
          console.log(e);
        }
      },
      getTraitName(traitId){
        try {
          return this.getTraitById(traitId).traitName;
        } catch (e) {
          console.log(e);
        }
      },
      async fetchTraitScoreDetails() {
        this.loading = true;

        this.traitScoreDetails = await dnaApi.fetchTraitScoreDetails();
        this.buildTraitSelectorOptions();

        this.loading = false;
      },
      async createTraitScore() {
        console.log('createTraitScore', this.newTraitScoreModel);
        this.newTraitScoreModel.trait_id = +this.newTraitScoreModel.trait_id;
        if (this.newTraitScoreModel.trait_id === 0 || isNaN(this.newTraitScoreModel.trait_id)) {
          this.showCreateTraitScoreDialog(this.newTraitScoreModel);
          this.showNotification(false, 'The trait ID must be a number.');
          return;
        }
        this.newTraitScoreModel.score = this.newTraitScoreModel.score.trim().toUpperCase();
        if (this.newTraitScoreModel.score.length === 0) {
          this.showCreateTraitScoreDialog(this.newTraitScoreModel);
          this.showNotification(false, '"score" is required.');
          return;
        }
        this.loading = true;

        let success = await api.createProductDnaTraitScore(this.newTraitScoreModel);

        if (success) {
          await this.fetchProductDnaTraitScores();
          this.showNotification(true, 'Trait/Score added');
        } else {
          this.showNotification(false, 'Error adding Trait/Score');
        }

        this.loading = false;
      },
      async fetchProductDnaTraitScores() {
        this.loading = true;
        this.traitScores = await api.fetchProductDnaTraitScores(this.productId);
        if (this.traitScoreDetails.length === 0) {
          await this.fetchTraitScoreDetails();
        }
        this.loading = false;
      },
      async deleteProductDnaTraitScore(traitScore) {
        this.loading = true;
        let success = await api.deleteProductDnaTraitScore(traitScore);

        if (success) {
          await this.fetchProductDnaTraitScores();
          this.showNotification(true, 'Trait/Score deleted');
        } else {
          this.showNotification(false, 'Error deleting Trait/Score');
        }
        this.loading = false;
      },
      showCreateTraitScoreDialog(traitScore) {
        if (traitScore instanceof models.ProductDnaTraitScore) {
          this.newTraitScoreModel = traitScore;
        } else {
          this.newTraitScoreModel = new models.ProductDnaTraitScore({ product_id: this.productId});
        }
        this.showCreateTraitScoreDialogFlag = true;
      },
      confirmDeleteTraitScore(traitScore) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          acceptText: 'DELETE',
          title: `DELETE ${traitScore.trait_id}-${traitScore.score}`,
          text: `Are you sure you want to delete this?`,
          accept: () => {
            this.deleteProductDnaTraitScore(traitScore);
          }
        })
      },
      showNotification(success, message) {
        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: message ? message : '',
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});
      },
    },
  }

</script>


<style lang="scss">

</style>

